<template>
  <v-container>
    <h2 style="color:gray">Cài Đặt Thời Khóa Biểu</h2>
    <v-divider class="my-3"></v-divider>
    <v-row class="py-3">
      <v-col cols="12">
        <v-checkbox
          v-model="policies"
          value="view-schedule-group"
          :label="'Cho phép ' + roleName + ' thiết lập thời khóa biểu'"
          hide-details
          class="ma-0 pa-0"
        ></v-checkbox>
      </v-col>

      <v-col cols="12">
        <v-divider></v-divider>
      </v-col>
      <v-col cols="12" md="6">
        <v-checkbox
          hide-details
          value="view-class-schedule"
          :label="'Cho phép ' + roleName + ' xem thời khóa biểu lớp'"
          v-model="policies"
          class="ma-0 pa-0"
        ></v-checkbox
      ></v-col>
      <v-col cols="12" md="6">
        <v-checkbox
          hide-details
          value="view-teacher-schedule"
          :label="'Cho phép ' + roleName + ' xem thời khóa biểu giáo viên'"
          v-model="policies"
          class="ma-0 pa-0"
        ></v-checkbox>
      </v-col>
      <v-col cols="12" md="6">
        <v-checkbox
          hide-details
          value="config-class-schedule"
          :label="'Cho phép ' + roleName + ' xếp thời khóa biểu'"
          v-model="policies"
          class="ma-0 pa-0"
        ></v-checkbox>
      </v-col>
    </v-row>
    <v-divider class="my-3"></v-divider>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn color="primary" text class="mx-5" @click="reset()">Đặt lại</v-btn>
      <v-btn color="primary" @click="save()">Lưu</v-btn>
    </v-card-actions>
  </v-container>
</template>

<script>
import mixins from './helper/mixins'
export default {
  mixins: [mixins]
}
</script>
